module.exports = __webpack_public_path__ + "img/solar-system.7703044f.svg";